import { useState } from "react";
import { Copy, Check } from "lucide-react";

export const CopyReadingButton = ({ text, testid = "copy-reading-btn" }) => {
  const [copied, setCopied] = useState(false);

  const legacyCopy = () => {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  };

  const copy = async () => {
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(text);
      else legacyCopy();
    } catch {
      legacyCopy();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <button onClick={copy} data-testid={testid}
      className="inline-flex items-center gap-1.5 text-[11px] text-amber-200 border border-amber-500/40 rounded-full px-3.5 py-1 hover:bg-amber-500/10 transition-colors">
      {copied ? <Check className="w-3 h-3 text-emerald-300" /> : <Copy className="w-3 h-3" />}
      <span data-testid={`${testid}-label`}>{copied ? "Testo copiato" : "Copia testo"}</span>
    </button>
  );
};
